import add from '@iconify/icons-ic/add';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  InputAdornment,
  Grid,
  Autocomplete,
  TextField
} from '@mui/material';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { useDispatch } from 'react-redux';
import { RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { getBankDropdownData } from '../../store/Slice/Global/GlobalSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export default function PayoutToolbar({
  parent,
  selectStatus,
  setSelectStatus,
  filterName,
  onFilterName,
  filterParameter,
  setFilterParameter,
  handleDownload,
  typeIdValue
}) {
  const [isOpenFilter, setOpenFilter] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();
  const { MasterTypeListDrop, BankDrop, CityDrop, LoanTypeDrop } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setSelectStatus(' ');

    setFilterParameter((pre) => ({
      bankId: null,
      cityId: null,
      loanTypeId: null
    }));
  };

  const getBankDropApi = useCallback(() => {
    if (!LoginData) return;
    const data = { companyId: LoginData?.companyId, userId: LoginData?.userId };
    dispatch(getBankDropdownData(data));
  }, [LoginData]);

  useEffect(() => {
    getBankDropApi();
  }, [getBankDropApi]);

  return (
    <>
      {isOpenFilter && (
        <Box sx={{ pt: 2 }}>
          <Grid
            container
            style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
            spacing={3}
          >
            <Grid item size={{ md: 6, sm: 6, xs: 12 }}>
              {' '}
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.loanTypeId}`
                }}
                value={filterParameter?.loanTypeId || ' '}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    loanTypeId: e.target?.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item size={{ md: 4, sm: 6, xs: 12 }} sx={{ minWidth: 200 }}>
              <Autocomplete
                id="combo-box-demo2"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank" />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankName) || null}
                onChange={(e, newValue) => {
                  // handleBranchDetails(newValue);
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.cityId}`
                }}
                value={filterParameter?.cityId || ' '}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    cityId: e.target?.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select City
                </MenuItem>
                {CityDrop?.length > 0 &&
                  CityDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>

            <Grid item size={{ md: 2, sm: 6, xs: 12 }}>
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}
      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1',
          alignItems: 'center'
        }}
      >
        <Box>
          <Tooltip title="Add New File" placement="top" arrow>
            <IconButton className="squareIconButton" onClick={(e) => navigate(`/${parent}/add`)}>
              <Icon icon={add} width={18} />
            </IconButton>
          </Tooltip>{' '}
          &nbsp;
          <Tooltip title="Upload" placement="top" arrow>
            <IconButton className="squareIconButton" onClick={(e) => navigate(`/${parent}/upload`)}>
              <BiCloudUpload size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title="Download" placement="top" arrow>
            <IconButton className="squareIconButton" onClick={(e) => handleDownload(typeIdValue)}>
              <BiCloudDownload size={18} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Payout"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  setOpenFilter(false);
                } else {
                  setOpenFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
